<template>
  <footer class="interact footer">              
    <ul>
      <!-- <li>
        <a data-toggle="modal" data-target="#callMeBackModal">Call Me Back <i class="fa fa-phone" aria-hidden="true"></i></a>
      </li> -->
      <!-- <li>
        <a v-on:click="liveChat()">Live Chat <i class="fa fa-comments" aria-hidden="true"></i></a>
      </li> -->
    </ul>
  </footer>
</template>

<script>

export default {
  name: 'support-footer',
  methods: {    
  }  
}
</script>

<style lang="scss">
  .interact {
    a {
      cursor: pointer;
    }
  }
</style>
